import { render, staticRenderFns } from "./IrrigatorProfileFile.vue?vue&type=template&id=0633c5de&"
import script from "./IrrigatorProfileFile.vue?vue&type=script&lang=js&"
export * from "./IrrigatorProfileFile.vue?vue&type=script&lang=js&"
import style0 from "./IrrigatorProfileFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VFileInput,VIcon,VRow,VSimpleTable})
